module.exports = __webpack_public_path__ + "static/media/genji-justlogo.7b268fe7.png";